__turbopack_context__.v({
  "gridA": "styles-module__JJLzZq__gridA",
  "gridB": "styles-module__JJLzZq__gridB",
  "gridLayout": "styles-module__JJLzZq__gridLayout",
});
